// 入驻流程相关


export const SETTLE_PROCESS_CODE = {
  // 实名（根据场景拼接Url）
  'NAME': {
    text: '去实名认证',
    url: '',
    method: 'redirectTo'
  },
  // 实名信息确认
  'CONFIRM': {
    text: '去实名认证',
    url: '/pages/realname-confirm/index', 
    method: 'redirectTo'
  },
  // 开通
  'ACCOUNT': {
    text: '去实名认证',
    url: '/pages/register/index', 
    method: 'redirectTo'
  },
  'CARD': {
    text: '去设置结算卡',
    url: '/pages/banks/index',
    method: 'redirectTo'
  },
  // 上传证件（接口获取url）
  'CERT': {
    text: '去上传证件',
    url: '',
    method: 'redirectTo'
  },
  'USER': {
    text: '',
    url: '/pages/user/index',
    method: 'redirectTo'
  }
}

// 根据入驻状态生成操作队列字符串(实名-开通-结算卡-证件)
export const getActionQueueStr = (res) => {
  const { realnameStatus = 0, openStatus = 0, settleCardStatus = 0, certAuditStatus = 0 } = res;
  let actArr = [];
  // 实名状态判断
  switch (realnameStatus) {
    // 未实名
    case 0:
      actArr.push('NAME');
      break;
    // 实名注销
    case 2:
      actArr.push('NAME');
      actArr.push('CONFIRM');
      break;
      // 实名信息有更新
    case 3:
      actArr.push('CONFIRM');
      break;
      default:
      break;
  }
  // 开通状态判断
  switch (openStatus) {
    case 0:
      actArr.push('ACCOUNT');
      break;
    default:
      break;
  }
  // 结算卡状态判断
  if(settleCardStatus !== 1) {
    actArr.push('CARD');
  }
  // 证件审核状态判断
  if(certAuditStatus !== 1) {
    actArr.push('CERT')
  }
  actArr.push('USER');
  return actArr.join('-');
}

// 取出队列第一个操作和剩余队列串
export const pickFirstAction = (processStr) => {
  // 分割字符串生成数组
  const arr = processStr.split('-');
  return {
    actionCode: arr.shift(), // 第一个操作code
    processStr: arr.join('-') // 剩余操作串
  };
}